<template>
    <v-container
            fill-height
            fluid
            grid-list-xl
    >
        <v-layout wrap>
            <!--<v-flex
                    md12
                    sm12
                    lg12
            >

                <material-chart-card
                        :data="dailySalesChart.data"
                        :options="dailySalesChart.options"
                        color="info"
                        type="Line"
                >
                    <h4 class="title font-weight-light">Daily Sales</h4>
                    <p class="category d-inline-flex font-weight-light">
                        <v-icon
                                color="green"
                                small
                        >
                            arrow-up
                        </v-icon>
                        <span class="green&#45;&#45;text">55%</span>&nbsp;
                        increase in today's sales
                    </p>

                    <template slot="actions">
                        <v-icon
                                class="mr-2"
                                small
                        >
                            mdi-clock-outline
                        </v-icon>
                        <span class="caption grey&#45;&#45;text font-weight-light">updated 4 minutes ago</span>
                    </template>
                </material-chart-card>
            </v-flex>
            <v-flex
                    md12
                    sm12
                    lg4
            >
                <material-chart-card
                        :data="emailsSubscriptionChart.data"
                        :options="emailsSubscriptionChart.options"
                        :responsive-options="emailsSubscriptionChart.responsiveOptions"
                        color="red"
                        type="Bar"
                >
                    <h4 class="title font-weight-light">Email Subscription</h4>
                    <p class="category d-inline-flex font-weight-light">Last Campaign Performance</p>

                    <template slot="actions">
                        <v-icon
                                class="mr-2"
                                small
                        >
                            mdi-clock-outline
                        </v-icon>
                        <span class="caption grey&#45;&#45;text font-weight-light">updated 10 minutes ago</span>
                    </template>
                </material-chart-card>
            </v-flex>-->

            <v-flex xs6>
                <!--<v-layout>
                    <v-flex xs6>
                        <material-stats-card color="black" icon="mdi-account" title="Users" :value="'총 회원 수 : ' + users.length.toString()" v-if="users"  @click="goUsers"/>
                    </v-flex>
                    <v-flex xs6>
                        <material-stats-card color="black" icon="mdi-pencil" title="Contents" :value="'총 등록 수 : ' +   contents.length.toString()" v-if="contents" @click="goContents"/>
                    </v-flex>
                </v-layout>-->

                <v-layout>
                    <v-flex xs12>
                        <!--Month Member(월별 가입자)-->
<!--                        <material-card color="black" title="Month Member(월별 가입자)" text="">-->
                        <material-card color="black" title="EXA" text="">

                            <v-layout>
                                <v-flex xs6>
                                    <div v-if="users" class="text-center">
                                        <h5 class="font-weight-bold text-center">총 회원 수</h5>
                                        <h1 class="mt-1 text-center">{{users.length.toString() | number}}</h1>
                                    </div>
                                </v-flex>
                                <v-flex xs6>
                                    <div v-if="contents" class="text-center">
                                        <h5 class="font-weight-bold text-center">총 등록 수</h5>
                                        <h1 class="mt-1 text-center">{{contents.length.toString() | number}}</h1>
                                    </div>
                                </v-flex>
                            </v-layout>

                            <hr/>

                            <h5 class="font-weight-bold text-center">가입자 현황</h5>
                            <v-data-table :headers="HEADERS_DASHBOARD_MONTH" :items="member_month_list" hide-actions>
                                <template slot="headerCell" slot-scope="{ header }">
                                    <span class="font-weight-light text--darken-3" style="font-size: 15px !important;" v-text="header.text"/>
                                </template>
                                <template slot="items" slot-scope="{ index, item }">
                                    <tr>
<!--                                        <td class="text-xs-center">{{ item.name}}</td>-->
                                        <td class="text-xs-center">{{ item.Traveler | number }}</td>
                                        <td class="text-xs-center">{{ item.EXtremer | number }}</td>
                                        <td class="text-xs-center">{{ item.Manager | number }}</td>
                                        <td class="text-xs-center">{{ item.GrowthDirector | number }}</td>
                                    </tr>
                                </template>
                            </v-data-table>

                            <hr/>

                            <h5 class="font-weight-bold text-center">콘텐츠 현황</h5>
                            <v-data-table :headers="HEADERS_DASHBOARD_CONTENTS_MONTH" :items="content_month_list" hide-actions>
                                <template slot="headerCell" slot-scope="{ header }">
                                    <span class="font-weight-light text--darken-3" style="font-size: 15px !important;" v-text="header.text"/>
                                </template>
                                <template slot="items" slot-scope="{ index, item }">
                                    <tr >
<!--                                        <td class="text-xs-center">{{ item.name }}</td>-->
                                        <td class="text-xs-center">{{ item.category_00 | number }}</td>
                                        <td class="text-xs-center">{{ item.category_01 | number }}</td>
                                        <td class="text-xs-center">{{ item.category_02 | number }}</td>
                                        <td class="text-xs-center">{{ item.category_03 | number }}</td>
                                        <td class="text-xs-center">{{ item.category_04 | number }}</td>
                                        <td class="text-xs-center">{{ item.category_05 | number }}</td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </material-card>
                    </v-flex>
                </v-layout>
<!--
                <v-layout>
                    <v-flex xs12>
                        <material-card color="black" title="Month Contents(월별 콘텐츠)" text="">
                            <v-data-table :headers="HEADERS_DASHBOARD_CONTENTS_MONTH" :items="content_month_list" hide-actions>
                                <template slot="headerCell" slot-scope="{ header }">
                                    <span class="font-weight-light text&#45;&#45;darken-3" v-text="header.text"/>
                                </template>
                                <template slot="items" slot-scope="{ index, item }">
                                    <tr >
                                        <td class="text-xs-center">{{ item.name }}</td>
                                        <td class="text-xs-center">{{ item.category_00}}</td>
                                        <td class="text-xs-center">{{ item.category_01}}</td>
                                        <td class="text-xs-center">{{ item.category_02}}</td>
                                        <td class="text-xs-center">{{ item.category_03}}</td>
                                        <td class="text-xs-center">{{ item.category_04}}</td>
                                        <td class="text-xs-center">{{ item.category_05}}</td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </material-card>
                    </v-flex>
                </v-layout>
                -->
            </v-flex>

            <v-flex xs6>
                <material-card color="black" title="회원현황" text="" icon="mdi-trophy-variant">
                    <h4 class="my-0" v-if="newUserCount">신규 가입자 (명)</h4>
                    <line-chart-board v-if="newUserChart" :data="newUserChart" @changeDate="changeNewUserChartDate" ref="newUserChart"></line-chart-board>
                </material-card>
            </v-flex>

            <v-flex xs6>
                <material-card color="black" title="콘텐츠 현황" text="">
                    <h4 class="my-0" v-if="newContentsCount">신규 콘텐츠 (개)</h4>
                    <line-chart-board v-if="contentsChart" :data="contentsChart" @changeDate="changeNewContentsChartDate" ref="newContentsChart"></line-chart-board>
                </material-card>
            </v-flex>

            <!--
            <v-flex sm6 xs12 md6 lg6>
                <material-card color="orange" title="접속자 현황" text="">

                    <v-layout align-center>
                        <v-flex sm4>
                            <h4 class="my-0">일별 가입자 (명)</h4>
                        </v-flex>
                        <v-flex sm8>
                            <div style="text-align: right">
                                <v-btn depressed small @click="showTab(0)" :color="showAccessChart == 0 ? 'orange':''">일별</v-btn>
                                <v-btn depressed small @click="showTab(1)" :color="showAccessChart == 1 ? 'orange':''">시간별</v-btn>
                            </div>
                        </v-flex>
                    </v-layout>

                    <line-chart-board :data="joinDailyChart" :class="showAccessChart == 0 ? 'showChart':'hideChart'"></line-chart-board>
                    <line-chart-board :data="joinTimelyChart" :class="showAccessChart == 1 ? 'showChart':'hideChart'"></line-chart-board>
                </material-card>
            </v-flex>
            -->

            <v-flex xs6>
                <material-card color="black" title="접속 빈도" text="">
                    <h4 class="my-0" v-if="accessUserCount">유효 접속자 (명)</h4>
                    <line-chart-board v-if="accessUserChart" :data="accessUserChart" @changeDate="changeAccessUserChartDate" ref="accessUserChart"></line-chart-board>
                </material-card>
            </v-flex>

<!--
            <v-flex sm6 xs12 md6 lg6>
                &lt;!&ndash;<material-stats-card color="orange" style="white-space: pre-line" icon="mdi-store" title="Users" :value="users_counter" v-if="users" @click="goUsers"/>&ndash;&gt;
&lt;!&ndash;                <material-stats-card color="orange" icon="mdi-store" title="Users" :value="'총 회원 수 : ' + users.length.toString()" v-if="users"  :subList="member_list" @click="goUsers"/>&ndash;&gt;
                <material-stats-card color="orange" icon="mdi-store" title="Users" :value="'총 회원 수 : ' + users.length.toString()" v-if="users"  @click="goUsers"/>
            </v-flex>
            <v-flex sm6 xs12 md6 lg6>
                <material-stats-card color="green" icon="mdi-content-copy" title="Contents" :value="'총 등록 수 : ' +   contents.length.toString()" v-if="contents" @click="goContents"/>
            </v-flex>
            -->
<!--

            &lt;!&ndash;Month Member(월별 가입자)&ndash;&gt;
            <v-flex md12 lg6>
                <material-card color="black" title="Month Member(월별 가입자)" text="">
                    <v-data-table :headers="HEADERS_DASHBOARD_MONTH" :items="member_month_list" hide-actions>
                        <template slot="headerCell" slot-scope="{ header }">
                            <span class="font-weight-light text&#45;&#45;darken-3" v-text="header.text"/>
                        </template>
                        <template slot="items" slot-scope="{ index, item }">
                            <tr>
                                <td class="text-xs-center">{{ item.name }}</td>
                                <td class="text-xs-center">{{ item.Traveler}}</td>
                                <td class="text-xs-center">{{ item.EXtremer}}</td>
                                <td class="text-xs-center">{{ item.Manager}}</td>
                                <td class="text-xs-center">{{ item.GrowthDirector}}</td>

                            </tr>
                        </template>
                    </v-data-table>
                </material-card>
            </v-flex>
-->
<!--

            &lt;!&ndash;Month Contents(월별 콘텐츠)&ndash;&gt;
            <v-flex md12 lg6>
                <material-card color="black" title="Month Contents(월별 콘텐츠)" text="">
                    <v-data-table :headers="HEADERS_DASHBOARD_CONTENTS_MONTH" :items="content_month_list" hide-actions>
                        <template slot="headerCell" slot-scope="{ header }">
                            <span class="font-weight-light text&#45;&#45;darken-3" v-text="header.text"/>
                        </template>
                        <template slot="items" slot-scope="{ index, item }">
                            <tr >
                                <td class="text-xs-center">{{ item.name }}</td>
                                <td class="text-xs-center">{{ item.category_00}}</td>
                                <td class="text-xs-center">{{ item.category_01}}</td>
                                <td class="text-xs-center">{{ item.category_02}}</td>
                                <td class="text-xs-center">{{ item.category_03}}</td>
                                <td class="text-xs-center">{{ item.category_04}}</td>
                                <td class="text-xs-center">{{ item.category_05}}</td>

                            </tr>
                        </template>
                    </v-data-table>
                </material-card>
            </v-flex>
-->

            <!--Recent Member(최근 가입자)-->
            <v-flex md12 lg6>
                <material-card color="black" title="Recent Member(최근 가입자)" text="">
                    <v-data-table :headers="HEADERS_DASHBOARD_USERS" :items="users.slice(0,5)" hide-actions>
                        <template slot="headerCell" slot-scope="{ header }">
                            <span class="font-weight-light text--darken-3 text-center" v-text="header.text"/>
                        </template>
                        <template slot="items" slot-scope="{ index, item }">
                            <tr @click="selectUser(item)">
                                <td class="text-xs-center">{{ index + 1 }}</td>
                                <td class="text-xs-center">{{ TYPE_MEMBER_TYPE[item.type]}}</td>
                                <td class="text-xs-center">{{ item.nickname }}</td>
                                <td class="text-xs-left">{{ item.email }}</td>
                                <td class="text-xs-center">{{ item.sns_type }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                </material-card>
            </v-flex>

            <!--Recent Contents(최근 콘텐츠-->
            <v-flex md12 lg6>
                <material-card color="black" title="Recent Contents(최근 콘텐츠)" text="">
                    <v-data-table :headers="HEADERS_DASHBOARD_CONTENTS" :items="contents.slice(0,5)" hide-actions>
                        <template slot="headerCell" slot-scope="{ header }">
                            <span class="font-weight-light  text--darken-3 text-center" v-text="header.text"/>
                        </template>
                        <template slot="items" slot-scope="{ index, item }">
                            <tr @click="selectContent(item)">
                                <td class="text-xs-center">{{ index + 1 }}</td>
                                <td class="text-xs-center">{{ item.id }}</td>
                                <td class="text-xs-center">{{ item.type  }}</td>
                                <td class="text-xs-left">{{ item.title }}</td>
                                <td class="text-xs-center">{{ item.user.nickname }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                </material-card>
            </v-flex>

            <!--Rank Contents -->
            <v-flex md12 lg6>

                <material-card color="black" title="Content Registration Rank(콘텐츠등록 순위 - 누적)"  subtitle="11" text="" >
                    <div class="text-xs-right">
                        <v-menu offset-y>
                            <template slot="activator" slot-scope="{ on}">
                                <v-layout>
                                    <h5 class="ml-4 font-weight-bold mr-auto">total : {{contents.length | number }}</h5>
                                    <v-btn outline color="black" dark v-on="on">Row : {{content_rank_member_count | number }}</v-btn>
                                </v-layout>
                            </template>
                            <v-list>
                                <v-list-tile
                                        v-for="(item, index) in items"
                                        :key="index"
                                        @click="changeCount(item.number,'member')"
                                >
                                    <v-list-tile-title>{{ item.number  | number }}</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                    </div>
                    <v-data-table :headers="HEADERS_DASHBOARD_CONTENTS_MEMBER_RANK" :items="content_rank_member.slice(0,content_rank_member_count)" hide-actions>
                        <template slot="headerCell" slot-scope="{ header }">
                            <span class="font-weight-light  text--darken-3" v-text="header.text"/>
                        </template>
                        <template slot="items" slot-scope="{ index, item }">
                            <tr >
                                <td class="text-xs-center">{{ index + 1 }}</td>
                                <td class="text-xs-center">{{ item.nickname  }}</td>
                                <td class="text-xs-center">{{ item.value  | number }}</td>
                            </tr>
                        </template>
                    </v-data-table>

                </material-card>
            </v-flex>

            <!--Rank Reiview-->
            <v-flex md12 lg6>
                <material-card color="black" title="Reviews Registration Rank(리뷰등록 순위 - 누적)" text="">

                    <div class="text-xs-right">

                        <v-menu offset-y>
                            <template slot="activator" slot-scope="{ on}">
                                <v-layout>
                                    <h5 class="ml-4 font-weight-bold mr-auto">total : {{reviews.length | number }}</h5>
                                    <v-btn outline color="black" dark v-on="on">Row : {{content_rank_review_count | number }}</v-btn>
                                </v-layout>

                            </template>
                            <v-list>
                                <v-list-tile
                                        v-for="(item, index) in items"
                                        :key="index"
                                        @click="changeCount(item.number,'review')"
                                >
                                    <v-list-tile-title>{{ item.number | number }}</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                    </div>
                    <v-data-table :headers="HEADERS_DASHBOARD_CONTENTS_RIVIEW_RANK" :items="content_rank_review.slice(0,content_rank_review_count)" hide-actions>
                        <template slot="headerCell" slot-scope="{ header }">
                            <span class="font-weight-light text-center text--darken-3" v-text="header.text"/>
                        </template>
                        <template slot="items" slot-scope="{ index, item }">
                            <tr @click="selectCommnet(item)">
                                <td class="text-xs-center">{{ index + 1 }}</td>
                                <td class="text-xs-center" >{{ item.contents_id}}</td>
                                <td class="text-xs-center" >  {{ item.value ? item.value : ""  | number }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                </material-card>
            </v-flex>

            <!--Rank  Like-->
            <v-flex md12 lg6>

                <material-card color="black" title="likes Registration Rank(좋아요등록 순위 - 누적)"  subtitle="11" text="" >
                    <div class="text-xs-right">
                        <v-menu offset-y>
                            <template slot="activator" slot-scope="{ on}">
                                <v-layout>
                                    <h5 class="ml-4 font-weight-bold mr-auto">total : {{likes.length | number }}</h5>
                                    <v-btn outline color="black" dark v-on="on">Row : {{content_rank_like_count | number }}</v-btn>
                                </v-layout>

                            </template>
                            <v-list>
                                <v-list-tile
                                        v-for="(item, index) in items"
                                        :key="index"
                                        @click="changeCount(item.number,'like')"
                                >
                                    <v-list-tile-title>{{ item.number }}</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                    </div>
                    <v-data-table :headers="HEADERS_DASHBOARD_CONTENTS_LIKE_RANK" :items="content_rank_like.slice(0,content_rank_like_count)" hide-actions>
                        <template slot="headerCell" slot-scope="{ header }">
                            <span class="font-weight-light  text--darken-3" v-text="header.text"/>
                        </template>
                        <template slot="items" slot-scope="{ index, item }">
                            <tr >
                                <td class="text-xs-center">{{ index + 1 }}</td>
                                <td class="text-xs-center">{{ item.contents_id }}</td>
                                <td class="text-xs-left" >{{ item.content_title}}</td>
                                <td class="text-xs-center">{{ item.value  | number }}</td>
                            </tr>
                        </template>
                    </v-data-table>

                </material-card>
            </v-flex>

            <!--Rank Pick-->
            <v-flex md12 lg6>
                <material-card color="black" title="Pick Registration Rank(찜 등록 순위 - 누적)" text="">

                    <div class="text-xs-right">

                        <v-menu offset-y>
                            <template slot="activator" slot-scope="{ on}">
                                <v-layout>
                                    <h5 class="ml-4 font-weight-bold mr-auto">total : {{picks.length | number }}</h5>
                                    <v-btn outline color="black" dark v-on="on">Row : {{content_rank_pick_count | number }}</v-btn>
                                </v-layout>
                            </template>
                            <v-list>
                                <v-list-tile
                                        v-for="(item, index) in items"
                                        :key="index"
                                        @click="changeCount(item.number,'pick')"
                                >
                                    <v-list-tile-title>{{ item.number }}</v-list-tile-title>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                    </div>
                    <v-data-table :headers="HEADERS_DASHBOARD_CONTENTS_PICK_RANK" :items="content_rank_pick.slice(0,content_rank_pick_count)" hide-actions>
                        <template slot="headerCell" slot-scope="{ header }">
                            <span class="font-weight-light  text--darken-3" v-text="header.text"/>
                        </template>
                        <template slot="items" slot-scope="{ index, item }">
                            <tr @click="selectCommnet(item)">
                                <td class="text-xs-center">{{ index + 1 }}</td>
                                <td class="text-xs-center" >{{ item.contents_id}}</td>
                                <td class="text-xs-left" >{{ item.content_title}}</td>
                                <td class="text-xs-center" >  {{ item.value ? item.value : ""  | number }}</td>
                            </tr>
                        </template>
                    </v-data-table>

                </material-card>
            </v-flex>
            <v-flex sm6 xs12 md6 lg6>
                <!--<material-chart-card
                        :data="users_pie"
                        color="white"
                        type="Pie"
                        :options="users_pie.options"
                          :responsive-options="users_pie.responsiveOptions"
                >
                    <h3 class="title font-weight-light">Users</h3>


                </material-chart-card>

                <material-chart-card
                        :data="users_pie"
                        color="gray"
                        type="Pie"
                >
                    <h3 class="title font-weight-light">Users Type</h3>
                    <p class="category d-inline-flex font-weight-light">Last Last Campaign Performance</p>

                    <template slot="actions">
                        <v-icon
                                class="mr-2"
                                small
                        >
                            mdi-clock-outline
                        </v-icon>
                        <span class="caption grey&#45;&#45;text font-weight-light"></span>
                    </template>
                </material-chart-card>-->
            </v-flex>
            <v-flex md12 lg6>

                <!--<material-card
                        class="card-tabs"
                        color="green">
                    <v-flex
                            slot="header"
                    >
                        <v-tabs
                                v-model="tabs"
                                color="transparent"
                                slider-color="white"
                        >
              <span
                      class="subheading font-weight-light mr-3"
                      style="align-self: center"
              >Tasks:</span>
                            <v-tab class="mr-3">
                                <v-icon class="mr-2">mdi-bug</v-icon>
                                Bugs
                            </v-tab>
                            <v-tab class="mr-3">
                                <v-icon class="mr-2">mdi-code-tags</v-icon>
                                Website
                            </v-tab>
                            <v-tab>
                                <v-icon class="mr-2">mdi-cloud</v-icon>
                                Server
                            </v-tab>
                        </v-tabs>
                    </v-flex>

                    <v-tabs-items v-model="tabs">
                        <v-tab-item
                                v-for="n in 3"
                                :key="n"
                        >
                            <v-list three-line>
                                <v-list-tile @click="complete(0)">
                                    <v-list-tile-action>
                                        <v-checkbox
                                                :value="list[0]"
                                                color="green"
                                        />
                                    </v-list-tile-action>
                                    <v-list-tile-title>
                                        Sign contract for "What are conference organized afraid of?"
                                    </v-list-tile-title>
                                    <div class="d-flex">
                                        <v-tooltip
                                                top
                                                content-class="top">
                                            <v-btn
                                                    slot="activator"
                                                    class="v-btn&#45;&#45;simple"
                                                    color="success"
                                                    icon
                                            >
                                                <v-icon color="primary">mdi-pencil</v-icon>
                                            </v-btn>
                                            <span>Edit</span>
                                        </v-tooltip>
                                        <v-tooltip
                                                top
                                                content-class="top">
                                            <v-btn
                                                    slot="activator"
                                                    class="v-btn&#45;&#45;simple"
                                                    color="danger"
                                                    icon
                                            >
                                                <v-icon color="error">mdi-close</v-icon>
                                            </v-btn>
                                            <span>Close</span>
                                        </v-tooltip>

                                    </div>
                                </v-list-tile>
                                <v-divider/>
                                <v-list-tile @click="complete(1)">
                                    <v-list-tile-action>
                                        <v-checkbox
                                                :value="list[1]"
                                                color="success"
                                        />
                                    </v-list-tile-action>
                                    <v-list-tile-title>
                                        Lines From Great Russian Literature? Or E-mails From My Boss?
                                    </v-list-tile-title>
                                    <div class="d-flex">
                                        <v-tooltip
                                                top
                                                content-class="top">
                                            <v-btn
                                                    slot="activator"
                                                    class="v-btn&#45;&#45;simple"
                                                    color="success"
                                                    icon
                                            >
                                                <v-icon color="primary">mdi-pencil</v-icon>
                                            </v-btn>
                                            <span>Edit</span>
                                        </v-tooltip>

                                        <v-tooltip
                                                top
                                                content-class="top">
                                            <v-btn
                                                    slot="activator"
                                                    class="v-btn&#45;&#45;simple"
                                                    color="danger"
                                                    icon>
                                                <v-icon color="error">mdi-close</v-icon>
                                            </v-btn>
                                            <span>Close</span>
                                        </v-tooltip>
                                    </div>
                                </v-list-tile>
                                <v-divider/>
                                <v-list-tile @click="complete(2)">
                                    <v-list-tile-action>
                                        <v-checkbox
                                                :value="list[2]"
                                                color="success"
                                        />
                                    </v-list-tile-action>
                                    <v-list-tile-title>
                                        Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit
                                    </v-list-tile-title>
                                    <div class="d-flex">
                                        <v-tooltip
                                                top
                                                content-class="top">
                                            <v-btn
                                                    slot="activator"
                                                    class="v-btn&#45;&#45;simple"
                                                    color="success"
                                                    icon
                                            >
                                                <v-icon color="primary">mdi-pencil</v-icon>
                                            </v-btn>
                                            <span>Edit</span>
                                        </v-tooltip>
                                        <v-tooltip
                                                top
                                                content-class="top">
                                            <v-btn
                                                    slot="activator"
                                                    class="v-btn&#45;&#45;simple"
                                                    color="danger"
                                                    icon
                                            >
                                                <v-icon color="error">mdi-close</v-icon>
                                            </v-btn>
                                            <span>Close</span>
                                        </v-tooltip>

                                    </div>
                                </v-list-tile>
                            </v-list>
                        </v-tab-item>
                    </v-tabs-items>
                </material-card>-->
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

	import { mapActions,mapGetters } from 'vuex'
	import * as dashboardApi from '../../service/api/dashboard-api'
	import * as userApi from '../../service/api/user-api'
	import * as contentsApi from '../../service/api/contents-api'
	import * as commentsApi from '../../service/api/comments-api'
	import * as picksApi from '../../service/api/picks-api'
	import * as likesApi from '../../service/api/likes-api'
	import MyMixinCommon from '../../mixins/MyMixinCommon';
	import moment from 'moment-timezone'
    import LineChartBoard from "../../components/dashboard/LineChartBoard";
    import LineChart from "../../components/chart/LineChart";


	export default {
        components: {
            LineChart,
            LineChartBoard,
        },
        mixins: [ MyMixinCommon ],
		data () {
			return {

			    showAccessChart: 0,

                // 기본 배열
				users :[],
				contents:[],
				reviews:[],
				picks:[],
				likes:[],

				// 월간 배열
                content_month_list:[],
				member_month_list:[],

                // 월간 배열을 위한
				member_list : this.OPTIONS_MEMBER_TYPE,
				category_list : this.OPTIONS_CATEGORY,


				// 랭크 배열

				content_rank_member:[],
				content_rank_review:[],
				content_rank_pick:[],
				content_rank_like:[],

				content_rank_member_count : 10,
				content_rank_review_count : 10,
				content_rank_pick_count : 10,
				content_rank_like_count : 10,


                //sort
				items: [
					{ number: 10 },
					{ number: 30 },
					{ number: 50 },

				],


				users_pie: {
					labels: [
						"Traveler",
						"EXtremer",
						"Manager",
						"GrowthDirector",
					],
					series: [ 0, 0, 0, 0 ],
					options: {
						lineSmooth: this.$chartist.Interpolation.cardinal( {
							tension: 0
						} ),
					},
					responsiveOptions: [
						[ 'screen and (min-width: 640px)', {
							chartPadding: 30,
							labelOffset: 100,
							labelDirection: 'explode',
							labelInterpolationFnc: function( value ) {
								return value;
							}
						} ],
						[ 'screen and (min-width: 1024px)', {
							labelOffset: 80,
							chartPadding: 0
						} ]
					]

				},



				search_condition :{
					user_id :null,
					type :null,
					sns_type :null,
					sns_id :null,
					refresh_token :null,
					nickname :null,
					email :null,
					created_at :null,
					updated_at :null,
					deleted_at :null,
				},
				dailySalesChart: {
					data: {
						labels: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
						series: [
							[12, 17, 7, 17, 23, 18, 38]
						]
					},
					options: {
						lineSmooth: this.$chartist.Interpolation.cardinal({
							tension: 0
						}),
						low: 0,
						high: 50, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
						chartPadding: {
							top: 0,
							right: 0,
							bottom: 0,
							left: 0
						}
					}
				},
				dataCompletedTasksChart: {
					data: {
						labels: ['12am', '3pm', '6pm', '9pm', '12pm', '3am', '6am', '9am'],
						series: [
							[230, 750, 450, 300, 280, 240, 200, 190]
						]
					},
					options: {
						lineSmooth: this.$chartist.Interpolation.cardinal({
							tension: 0
						}),
						low: 0,
						high: 1000, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
						chartPadding: {
							top: 0,
							right: 0,
							bottom: 0,
							left: 0
						}
					}
				},
				emailsSubscriptionChart: {
					data: {
						labels: ['Ja', 'Fe', 'Ma', 'Ap', 'Mai', 'Ju', 'Jul', 'Au', 'Se', 'Oc', 'No', 'De'],
						series: [
							[542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895]

						]
					},
					options: {
						axisX: {
							showGrid: false
						},
						low: 0,
						high: 1000,
						chartPadding: {
							top: 0,
							right: 5,
							bottom: 0,
							left: 0
						}
					},
					responsiveOptions: [
						['screen and (max-width: 640px)', {
							seriesBarDistance: 5,
							axisX: {
								labelInterpolationFnc: function (value) {
									return value[0]
								}
							}
						}]
					]
				},


				tabs: 0,
				list: {
					0: false,
					1: false,
					2: false
				},


                newUserChart: null,
                contentsChart: null,
                accessUserChart: null,

                newUserCount: 0,
                newContentsCount: 0,
                accessUserCount: 0,

                joinDailyChart: {
				    color: '#ffa726',
                    type: 'monthly',
                    data : {
                        labels: ['월', '화', '수', '목', '금', '토', '일'],
                        datasets: [
                            {
                                label: 'Data One',
                                backgroundColor: '#ffa726',
                                data: [40, 39, 10, 40, 39, 80, 40]
                            }
                        ]
                    },

                    options : {
                        responsive: true, maintainAspectRatio: false
                    },
                },

                joinTimelyChart: {
                    color: '#ffa726',
                    type: 'daily',
                    data : {
                        labels: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', ],
                        datasets: [
                            {
                                label: 'Data One',
                                backgroundColor: '#ffa726',
                                data: [40, 39, 10, 40, 39, 80, 40,40, 39, 10, 40, 39, 80, 40,40, 39, 10, 40, 39, 80, 40]
                            }
                        ]
                    },

                    options : {
                        responsive: true, maintainAspectRatio: false
                    },
                },


			}
		},
        created(){

			this.permissionCheck()


            this.member_list = this.OPTIONS_MEMBER_TYPE.slice(1,this.OPTIONS_MEMBER_TYPE.length)
            this.category_list = this.OPTIONS_CATEGORY.slice(1,this.OPTIONS_CATEGORY.length)



        },
		methods: {

			...mapGetters( 'user', [ 'getUserId', 'getLoginType' ] ),

            showTab( id ) {
                this.showAccessChart = id
                console.log(this.showAccessChart)
            },

			permissionCheck(){
				if(Number(this.getLoginType())  >= 3) {


				}else{

					this.$dialog.alert('관리자 권한이 없어 콘텐츠 페이지로 이동합니다.').then(dialog=>{
						this.$router.push( 'contents' )
					})

				}

				this.reqNewUserList()
                this.reqNewContentsList()
                this.reqAccessUserList()
				this.reqUserList()
				this.reqContentList()
				this.reqReviewList()
				this.reqLikeList()
				this.reqPickList()
            },

            reqNewUserList() {

			    let req = {
			       search_data: 'user',
                   search_type: 'd', //d: daily, m: monthly, h: hourly
                   start_date: moment(new Date()).tz("Asia/Seoul").format('YYYY-MM-DD')
                }

                this.getNewUserList( req )
            },

            getNewUserList( req ) {

                dashboardApi.retrieveDashboardData(req).then(res => {

                    if(res.data) {
                        let labels = []
                        let chartData = []
                        let data = res.data
                        let userCnt = 0
                        data.forEach( (d, i) => {
                            labels.push( d.date )
                            chartData.push( d.user )

                            userCnt += d.user
                        })

                        this.newUserCount = userCnt > 0 ? userCnt : '0'

                        this.newUserChart = {
                            type: 'monthly',
                            data : {
                                labels: labels,
                                datasets: [
                                    {
                                        label: '신규 가입자',
                                        backgroundColor: '#ffa726',
                                        data: chartData
                                    }
                                ]
                            },

                            options : {
                                responsive: true, maintainAspectRatio: false,
                                scales: {
                                    yAxes: [{
                                        ticks: {
                                            beginAtZero: true,
                                            stepSize: 1,
                                            callback: function(value, index, values) {
                                                if(parseInt(value) >= 1000){
                                                    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                                } else {
                                                    return value;
                                                }
                                            }
                                        },
                                        gridLines: {
                                            display: false
                                        }
                                    }],
                                    xAxes: [ {
                                        gridLines: {
                                            display: true
                                        },
                                    }]
                                }
                            },
                        }

                        if(this.$refs.newUserChart)
                            this.$refs.newUserChart.renderChart( this.newUserChart.data, this.newUserChart.options )
                    }
                })

            },

            reqNewContentsList() {

                let req = {
                    search_data: 'contents',
                    search_type: 'd', //d: daily, m: monthly, h: hourly
                    start_date: moment(new Date()).tz("Asia/Seoul").format('YYYY-MM-DD')
                }

                this.getNewContentsList( req )

            },

            getNewContentsList( req ) {

                dashboardApi.retrieveDashboardData(req).then(res => {

                    if(res.data) {
                        let labels = []
                        let chartData = []
                        let data = res.data
                        let contentsCnt = 0
                        data.forEach( (d, i) => {
                            labels.push( d.date )
                            chartData.push( d.contents )

                            contentsCnt += d.contents
                        })

                        this.newContentsCount = contentsCnt > 0 ? contentsCnt : '0'

                        this.contentsChart = {
                            type: 'monthly',
                            data : {
                                labels: labels,
                                datasets: [
                                    {
                                        label: '신규 콘텐츠',
                                        backgroundColor: '#66bb6a',
                                        data: chartData
                                    }
                                ]
                            },

                            options : {
                                responsive: true, maintainAspectRatio: false,
                                scales: {
                                    yAxes: [{
                                        ticks: {
                                            beginAtZero: true,
                                            stepSize: 1,
                                            callback: function(value, index, values) {
                                                if(parseInt(value) >= 1000){
                                                    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                                } else {
                                                    return value;
                                                }
                                            }
                                        },
                                        gridLines: {
                                            display: false
                                        }
                                    }],
                                    xAxes: [ {
                                        gridLines: {
                                            display: true
                                        },
                                    }]
                                }
                            },
                        }

                        if(this.$refs.newContentsChart)
                            this.$refs.newContentsChart.renderChart( this.contentsChart.data, this.contentsChart.options )
                    }
                })

            },


            reqAccessUserList() {

			    let date = moment(new Date()).tz("Asia/Seoul").format('YYYY-MM-DD')
                let req = {
                    search_data: 'accessUser',
                    search_type: 'd', //d: daily, m: monthly, h: hourly
                    start_date: date
                }

                this.getAccessUserList( req, moment(date).daysInMonth() )

            },

            getAccessUserList( req, daysInMonth ) {
                return dashboardApi.retrieveDashboardData(req).then(res => {

                    if (res.data) {
                        let labels = []
                        let dau = []
                        let mau = []
                        let data = res.data
                        let accessUserCnt = 0
                        data.forEach((d, i) => {
                            labels.push(d.date)
                            dau.push(d.dau)
                            mau.push(d.mau)

                            accessUserCnt += d.dau
                        })

                        this.accessUserCount = accessUserCnt > 0 ? Math.floor(accessUserCnt / daysInMonth) : '0'

                        this.accessUserChart = {
                            type: 'monthly',
                            data: {
                                labels: labels,
                                datasets: [
                                    {
                                        label: 'DAU',
                                        backgroundColor: '#66bb6a',
                                        data: dau
                                    },
                                    {
                                        label: 'MAU',
                                        backgroundColor: '#8be28f',
                                        data: mau
                                    }
                                ]
                            },

                            options: {
                                responsive: true, maintainAspectRatio: false,
                                scales: {
                                    yAxes: [{
                                        ticks: {
                                            beginAtZero: true,
                                            stepSize: 1,
                                            callback: function(value, index, values) {
                                                if(parseInt(value) >= 1000){
                                                    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                                } else {
                                                    return value;
                                                }
                                            }
                                        },
                                        gridLines: {
                                            display: false
                                        }
                                    }],
                                    xAxes: [ {
                                        gridLines: {
                                            display: true
                                        },
                                    }]
                                }
                            }
                        }

                        if(this.$refs.accessUserChart)
                            this.$refs.accessUserChart.renderChart( this.accessUserChart.data, this.accessUserChart.options )
                    }
                })
            },

            changeNewUserChartDate( date ) {

                let req = {
                    search_data: 'user',
                    search_type: 'd', //d: daily, m: monthly, h: hourly
                    start_date: date,
                }

                this.getNewUserList( req )
            },

            changeNewContentsChartDate( date ) {

                let req = {
                    search_data: 'contents',
                    search_type: 'd', //d: daily, m: monthly, h: hourly
                    start_date: date,
                }

                this.getNewContentsList( req )
            },

            changeAccessUserChartDate( date ) {

                let req = {
                    search_data: 'accessUser',
                    search_type: 'd', //d: daily, m: monthly, h: hourly
                    start_date: date,
                }

                this.getAccessUserList( req, moment(date).daysInMonth() )
            },

			// 기본 REQ
			reqUserList() {


				let req = this.search_condition

				if (req != null) {
					Object.keys(req).forEach((key) => (req[key] == null || req[key] == '') && delete req[key])
				}

				return userApi.retrieveUsers(req).then(res => {

					if(res.data)
					{
						this.users = res.data


						// this.member_list = []
						this.member_list.forEach(item =>{

							let temp = res.data.filter(member=>{return member.type == item.value})

							item['count'] = temp.length
						})

						this.makeMemberMonth()
						//this.users_pie.series =[traveler.length,eXtremer.length,manager.length,growthDirector.length]
					}

				}).catch(e=>{
					this.$dialog.alert(e.message)
				})
			},
			reqContentList() {


				let req = this.search_condition

				if (req != null) {
					Object.keys(req).forEach((key) => (req[key] == null || req[key] == '') && delete req[key])
				}


				return contentsApi.retrieveContents(req).then(res => {


					if(res.data)
					{
						this.contents = res.data


						// this.category_list = []
						this.category_list.forEach(item =>{

							let temp = res.data.filter(content=>{return content.category == item.value})

							item['count'] = temp.length
						})


						this.makeContentMonth()

						this.makeContentRankMember(this.contents )
					}

				}).catch(e=>{
					this.$dialog.alert(e.message)
				})
			},
			reqReviewList() {


				let req = this.search_condition

				if (req != null) {
					Object.keys(req).forEach((key) => (req[key] == null || req[key] == '') && delete req[key])
				}

				req.limit ='1000'
				// req.order ='popular'

				return commentsApi.retrieveComments( req ).then( res => {
                if( res.data ) {
						this.reviews = res.data


						this.makeContentRankReview( this.reviews )
					}

				} ).catch( e => {
					this.$dialog.alert( e.message )
				} )
			},
			reqLikeList() {


				let req = this.search_condition

				if (req != null) {
					Object.keys(req).forEach((key) => (req[key] == null || req[key] == '') && delete req[key])
				}

				delete req.limit

				return likesApi.retrieveLikes( req ).then( res => {

					if( res.data ) {
						this.likes = res.data


						this.makeContentRankLikes( this.likes )
					}

				} ).catch( e => {
					this.$dialog.alert( e.message )
				} )
			},
			reqPickList() {


				let req = this.search_condition

				if (req != null) {
					Object.keys(req).forEach((key) => (req[key] == null || req[key] == '') && delete req[key])
				}

				delete req.limit

				return picksApi.retrievePicks( req ).then( res => {
					if( res.data ) {
						this.picks = res.data


						this.makeContentRankPicks( this.picks )
					}

				} ).catch( e => {
					this.$dialog.alert( e.message )
				} )
			},

            // 월별
			makeMemberMonth(){

				this.member_month_list = []

				let data = {
					name: '전체',
				}

				this.member_list.forEach( ( item, index ) => {
					data[ item.text ] = item.count

				} )
				this.member_month_list.push( data )

/*

				// 월별 데이터 만들기
				let months =[]
				this.users.forEach( ( item, index ) => {

					let month = moment(new Date(item.created_at)).tz("Asia/Seoul").format('YYYY-MM')
					months.push(month)

				} )

				// 월별 유니크
				let unique = [...new Set(months)];


				unique.forEach(month=>{
					let data = {
						name: month,
					}

					this.member_list.forEach( ( member, index ) => {


						let members = this.users.filter( ( user, index ) => {
							let user_month = moment(new Date(user.created_at)).tz("Asia/Seoul").format('YYYY-MM')

							return this.TYPE_MEMBER_TYPE[user.type]== member.text && user_month  == month
						} )

						data[ member.text ] = members.length

					} )
					this.member_month_list.push( data )
				})
*/



			},
			makeContentMonth(){

				this.content_month_list = []

				let data = {
					name: '전체',
				}

				this.category_list.forEach( ( item, index ) => {
					data['category_0' + index ] = item.count
					// data[ item.text ] = item.count

				} )
				this.content_month_list.push( data )


                /*

				// 월별 데이터 만들기
				let months =[]
				this.users.forEach( ( item, index ) => {

					let month = moment(new Date(item.created_at)).tz("Asia/Seoul").format('YYYY-MM')
					months.push(month)

				} )

				// 월별 유니크
				let unique = [...new Set(months)];


				unique.forEach(month=>{
					let data = {
						name: month,
					}

					this.category_list.forEach( ( category, index ) => {


						let contents = this.contents.filter( ( content, index ) => {
							let content_month = moment(new Date(content.created_at)).tz("Asia/Seoul").format('YYYY-MM')
							return content.category== category.text && content_month  == month
						} )

						data['category_0' + index ] = contents.length

					} )

					this.content_month_list.push( data )
				})
*/
			},

            // 화면 이동
			goUsers(){
				this.$router.push( 'users' )
            },
			goContents(){
				this.$router.push( 'contents' )
			},

            // 셀 선택
			selectUser(user){

				this.$router.push( { name: 'user', params: { id: user.user_id } } );
            },
			selectContent(content){

				if (content.type == 'BOOK') {
					this.$router.push({name: 'content', params: {id: content.id}});
				}
			},
			selectCommnet(comment){



                if(comment) {
	                this.$router.push( { name: 'content', params: { id: comment.contents_id } } );
                }
			},

            // 셀 갯수 변경
			changeCount(item,type){

				if(type =='member'){
					this.content_rank_member_count = item
				}
				else if(type =='review') {
					this.content_rank_review_count= item
				}
				else if(type =='like') {
					this.content_rank_like_count= item
				}
				else if(type =='pick') {
					this.content_rank_pick_count= item
				}
			},

            // 콘텐츠 등록 회원 순위
			makeContentRankMember(contents){

				let users =[]

				contents.forEach(item=>{
					users.push(item.user.nickname)
				})


				const result = users.reduce((object, currentValue) => {
					if (!object[currentValue]) {
						object[currentValue] = 0;
					}
					object[currentValue]++;


					return object;
				}, {});



				let temp2 =[]

				for( const [ key, value ] of Object.entries( result ) ) {
					let data = {
						nickname: key,
						value: value
					}
					temp2.push( data )

				}


				temp2.sort( function( a, b ) { // 오름차순
					return a.value > b.value ? - 1 : a.value < b.value ? 1 : 0;
				} );

				this.content_rank_member = temp2

			},

			// 리뷰등록 콘텐츠 순위
			makeContentRankReview(reviews){

				let contents =[]

				reviews.forEach(item=>{
					contents.push(item.contents_id)
				})



				const result = contents.reduce((object, currentValue) => {
					if (!object[currentValue]) {
						object[currentValue] = 0;
					}
					object[currentValue]++;


					return object;
				}, {});






				let temp2 =[]

				for( const [ key, value ] of Object.entries( result ) ) {
					let data = {
						contents_id: key,
						value: value
					}
					temp2.push( data )

				}


				temp2.sort( function( a, b ) { // 오름차순
					return a.value > b.value ? - 1 : a.value < b.value ? 1 : 0;
				} );

				this.content_rank_review = temp2

			},

			// 좋아요등록 콘텐츠 순위
			makeContentRankLikes(likes){

				let contents =[]

				likes.forEach(item=>{
					contents.push(item.contents_id)
				})



				const result = contents.reduce((object, currentValue) => {
					if (!object[currentValue]) {
						object[currentValue] = 0;
					}
					object[currentValue]++;


					return object;
				}, {});




				let temp2 =[]

				for( const [ key, value ] of Object.entries( result ) ) {
					let data = {
						contents_id: key,
						value: value
					}

					let found = likes.find(function(like) {
						return like.contents_id == key;
					});

					data.content_title = found.content.title


					temp2.push( data )

				}



				temp2.sort( function( a, b ) { // 오름차순
					return a.value > b.value ? - 1 : a.value < b.value ? 1 : 0;
				} );

				this.content_rank_like = temp2



			},

			// 픽등록 콘텐츠 순위
			makeContentRankPicks(picks){

				let contents =[]

				picks.forEach(item=>{
					contents.push(item.contents_id)
				})


				const result = contents.reduce((object, currentValue) => {
					if (!object[currentValue]) {
						object[currentValue] = 0;
					}
					object[currentValue]++;


					return object;
				}, {});




				let temp2 =[]

				for( const [ key, value ] of Object.entries( result ) ) {
					let data = {
						contents_id: key,
						value: value

					}

					let found = picks.find(function(pick) {
						return pick.contents_id == key;
					});

					data.content_title = found.content.title



					temp2.push( data )

				}


				temp2.sort( function( a, b ) { // 오름차순
					return a.value > b.value ? - 1 : a.value < b.value ? 1 : 0;
				} );

				this.content_rank_pick= temp2

			},



		},
	}
</script>
<style lang="scss">
    .hideChart {
        position: relative;
        top:0;left:0;
        height:1px !important;
        overflow: hidden;
    }
    .showChart {
        position: relative;
        top: 0;
        left: 0;
        height: auto !important;
        min-height: 100px !important;
    }
    .text-center {
        text-align: center;
    }

    hr {
       margin: 20px 0;
    }


</style>
